/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Base from './base'
import { rootKey } from '../util'

export default class RegisteredParticipant extends Base {
  get defaults () {
    return { role: 'participant' }
  }

  get modelProperties () {
    return [
      'id',
      'email',
      'first_name',
      'last_name',
      'password',
      'role',
      'user_source'
    ]
  }

  initialize (opts) {
    if (opts == null) { opts = {} }
    if (opts.user) {
      // Disregard the id for the saved model
      opts.user.unset('id')
      return this.set(opts.user.attributes)
    }
  }

  url () {
    return '/users'
  }

  toJSON () {
    return rootKey('user', this.pick(this.modelProperties))
  }

  isLoggedIn () {
    return this.id > 0
  }

  isOnlyRegParticipant () {
    return !this.get('account_id')
  }
}
